export default __webpack_public_path__ + "static/media/red-swoop-alt-2.1ad8fe3b.png";